const installationInstructions = {
  intro: {
    currentStep: 'intro',
    headerIcon: 'arrowGrey',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    nextStep: 'powerOnCamera',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting a Looc camera!',
    haloDeviceResource: require('@/assets/device-models/PDR-01/Looc_halo.png'),
    resource: require('@/assets/device-models/PDR-01/Dahua_Looc_Outdoor.png'),
    resourceType: 'image',
    secondaryText: 'Let\'s get started with pairing your new camera.',
    continueButtonText: 'Start pairing',
  },
  powerOnCamera: {
    currentStep: 'powerOnCamera',
    headerIcon: 'arrowGrey',
    prevStepName: 'installationIntro',
    isLastPage: false,
    resourceType: 'image',
    resource: require('@/assets/device-models/PDR-01/Looc_Plug.png'),
    primaryText: 'Power on your camera',
    secondaryText: 'After you have assembled your Looc, plug it in using the supplied power adapter. The light on the front of your camera will turn on when the camera is on.',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStep: 'powerOnCamera',
    prevStepName: 'instructions',
    resourceType: 'video',
    resource: require('@/assets/device-models/PDR-01/blinking_looc.mp4'),
    poster: require('@/assets/device-models/PDR-01/blinking_looc_poster.png'),
    videoAutoPlay: 'autoplay',
    videoLoop: 'loop',
    videoType: 'video/mp4',
    videoControls: false,
    primaryText: 'Verify device is in pairing mode',
    secondaryText: 'It may take a few minutes after powering on the camera before it is in pairing mode. Ways to verify:',
    steps: [
      {
        title: 'Voice confirmation',
        description: 'You will hear a voice confirmation from the camera when it is ready to pair.',
        stepNumber: 1
      },
      {
        title: 'Blinking light pattern',
        description: 'The light will also turn to a double blinking green.',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    },
    continueButtonText: 'Ready',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/PDR-01/Reset-Looc_pairing.png'),
    primaryText: 'Putting Looc into Pairing Mode',
    secondaryText: 'If the light on the front of the camera is not double blinking green, it is not in pairing mode. To manually put the Looc into pairing mode:',
    steps: [
      {
        title: 'Press and hold',
        description: 'Press and hold the button on the top of your device for 10 seconds.',
        stepNumber: 1
      },
      {
        title: 'Release',
        description: 'Release the button as soon as you see the bottom light turn solid red.',
        stepNumber: 2
      },
      {
        title: 'Voice confirmation',
        description: 'After Looc finishes restarting, you will hear a voice confirmation indicating the camera is ready to pair. The light on the front of the camera will turn to double blinking green.',
        stepNumber: 3
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  }
};

export default installationInstructions;
